$(document).ready(function(){
    
    if ($('.header-notification').length) {
        $(window).on('scroll',function(){
            if ($(window).scrollTop() > 0) {
                $('.site-header').removeClass('site-header-offset');
            } else {
                $('.site-header').addClass('site-header-offset');
            }
        })
    }
    
    $('.nav-trigger').on('click',function(){
        $('.main-nav').addClass('visible');
    });
    
    $('.close-nav').on('click',function(){
        $('.main-nav').removeClass('visible');
    })

    if ($('.gallery').length) {
        
        const gallery = new Swiper('.gallery', {
            loop: true,
            centeredSlides:false,
            watchSlidesProgress: true,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                }
            }
        });
        
        const fullGallery = new Swiper('.full-gallery', {
            loop: true,
            centeredSlides:false,
            watchSlidesProgress: true,
            slidesPerView: 1,
            // arrows
            navigation: {
                nextEl: '.gallery-next',
                prevEl: '.gallery-prev',
            }
        });
        
        $('.gallery-img-show').on('click',function(){
            // get current slide index from gallery
            var index = gallery.realIndex + 1;
            fullGallery.slideTo(index,0);
            $('.full-gallery-wrap').addClass('visible');
        });
        
        $('.close-full-gallery').on('click',function(){
            $('.full-gallery-wrap').removeClass('visible');
        });
        $(document).keyup(function(e) { 
            if (e.keyCode == 27) { 
                $('.full-gallery-wrap').removeClass('visible');
            } 
        });
        
        $(document).on('click','.product-gallery-thumb',function(){
            var thumb = $(this);
            thumb.addClass('active').siblings().removeClass('active');
            // check for all variant slides in gallery 
            $('.product-gallery-slider').find('.variant-slide').fadeOut();
            setTimeout(function(){
                $('.product-gallery-slider').find('.variant-slide').remove();
            }, 500);
            var el = $(this);
            var slide = $('.gallery .swiper-slide[data-id="'+el.data('id')+'"]');
            gallery.slideTo(slide.data('swiper-slide-index')  + 1);
        });
        
        gallery.on('slideChange', function () { 
            var index = gallery.realIndex;
            var thumb = $('.product-gallery-thumb').eq(index);
            console.log(index, thumb);
            thumb.addClass('active').siblings().removeClass('active');
        });
        $('.product-gallery-thumb').eq(0).addClass('active');
    }
    
    $('.faq-item').on('click',function(){
        $(this).toggleClass('open');
        $(this).find('.answer').slideToggle();
    })
    
    if ($('.quantity').length) {
        var quantity = $('.quantity');
        var quantityVal = quantity.val();
        
        quantity.on('change',function(){
            quantityVal = quantity.val();
            if (quantityVal > 1) {
                $('.quantity-minus').removeClass('disabled');
            } else {
                $('.quantity-minus').addClass('disabled');
            }
        })
        
        $('.quantity-selector-item').on('click',function(e){
            e.preventDefault();
            
            if ($(this).hasClass('quantity-plus')) {
                quantity.get(0).value++
            } else {
                if (quantityVal > 1) {
                    quantity.get(0).value--
                }
            }
            quantityVal = quantity.val();
            quantity.trigger('change');
        });
        
        quantity.trigger('change');
    }
    
    if ($('.ProductSelect-2').length) {
        $('.add-to-cart-button').attr('disabled',true);
    };
    
    var selectedVariants = [];
    
    $('.colour-picker-item').on('click',function(){
        // Parent index 
        var parentIndex = $(this).parent().data('colour-picker');
        console.log(parentIndex);
        $('.ProductSelect-2').find('.colour-picker-item').removeClass('active');
        var variantSelected = '';
        var value = $(this).data('value');
        $(this).addClass('active').siblings().removeClass('active');
        $(this).parents().find('select').find('option[data-value="' + value + '"]').prop('selected', true);
        // Crate array that hold all selected variants
        
        selectedVariants[parentIndex] = value;
        console.log(selectedVariants);
        // Check if all variants are selected
        variantSelected = selectedVariants.join(' / ');
        // $('.product-option-select').each(function(k,v){
        //     if (k == $('.product-option-select').length - 1) {
        //         variantSelected +=  $(this).val();
        //     } else {
        //         variantSelected +=  $(this).val() + ' / ';
        //     }
        // });
        
        console.log(variantSelected);
        
        // Remove class active in last colour picker
        
        if ($('.ProductSelect-2').find('.active').length) {
            $('.variant-metafields').show().css('display','flex');
            $('.add-to-cart-button').attr('disabled',false);
        } else {
            $('.variant-metafields').slideUp();
            $('.add-to-cart-button').attr('disabled',true);
        }
        
        var selectedOption = $('#product-select').find('option[data-variant="' + variantSelected + '"]');
        var selectedOptionPrice = selectedOption.data('price');
        $('.product-price').html(selectedOptionPrice);
        
        
        selectedOption.prop('selected', true);
        
        if (selectedOption.data('length')) {
            $('.variant-length').text(selectedOption.data('length'));
        } else {
            $('.variant-length').text('');
            $('.variant-metafields').hide();
        }
        
        if (selectedOption.data('width')) {
            $('.variant-width').text(selectedOption.data('width'));
        } else {
            $('.variant-width').text('');
            $('.variant-metafields').hide();
        }
        
        if (selectedOption.data('weight')) {
            $('.variant-weight').text(selectedOption.data('weight'));
        } else {
            $('.variant-weight').text('');
            $('.variant-metafields').hide();
        }
        
        if (selectedOption.data('gallery') && $('.ProductSelect-2').find('.active').length) {
            var gallery = selectedOption.data('gallery').split(',');
            
            console.log(gallery);
            
            $('.gallery-thumbs').empty();
            
            // get swiper
            var swiper = document.querySelector('.swiper').swiper;
            $('.gallery').hide();
            swiper.removeAllSlides();
            
            gallery.forEach(function(item,index){
                $('.gallery-thumbs').append('<div data-id="' + index +'" class="product-gallery-thumb" data-id="'+item+'"><img src="'+item+'"></div>');
                // clear slides and add new
                swiper.appendSlide('<div class="swiper-slide slide-appended slide" data-id="'+index+'"><div class="product-gallery-image"><img class="gallery-img" src="'+item+'"></div></div>');
                // update swiper
                // Add autoplay to gallery
                swiper.autoplay.start();
                ZoomImages();
                swiper.update();
            }
        );
        $('.gallery').fadeIn();
    }
    
    $('#product-select').trigger('change');
    
    // hide and show productselect-2 options
    
    var firstTwoColours = variantSelected.split(' / ').slice(0,2).join(' / ');
    
    $('.ProductSelect-2').find('.colour-picker-item').each(function(){
        var lastColour = $(this).data('value');
        var variantSelected = firstTwoColours + ' / ' + lastColour;
        if ($('#product-select').find('option[data-variant="' + variantSelected + '"]').length) {
            if ($('.ProductSelect-0').find('.active').length && $('.ProductSelect-1').find('.active').length) {
                $(this).fadeIn();
            }
        } else {
            $(this).fadeOut();
        }
    });
    
    });

    $('#product-select').on('change',function(){
        var variantSelected = $(this).find('option:selected').val();
        if ($('.variant-slide[data-variant="' + variantSelected + '"]').length) {
            var variantSlide = $('.variant-slide[data-variant="' + variantSelected + '"]');
            variantSlide.find('img').attr('src', variantSlide.find('img').data('src'));
            var slideHTML = variantSlide.prop('outerHTML');
            $('.product-gallery-slider').append(slideHTML);
            $('.product-gallery-slider').find('.variant-slide').fadeIn();
            console.log(variantSlide, variantSlide.data('id'));
        } else {
            $('.product-gallery-slider').find('.variant-slide').fadeOut();
            setTimeout(function(){
                $('.product-gallery-slider').find('.variant-slide').remove();
            }, 500);
        }
    })


    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.site-header').outerHeight();

    $(window).on('scroll', function (event) {
        didScroll = true;
        if (window.pageYOffset > 0) {
            $('.site-header').addClass('site-header-bg');
        } else {
            $('.site-header').removeClass('site-header-bg');
        }
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        
        if (Math.abs(lastScrollTop - st) <= delta) return;
        
        if (st > lastScrollTop && st > navbarHeight) {
            if (!$('.megamenu').hasClass('visible')) {
                // Scroll Down
                $('.site-header').addClass('nav-up');
            }
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('.site-header').removeClass('nav-up');
            }
        }
        
        lastScrollTop = st;
    }

    // Change arrow font inside buttons

    $('button,a').each(function(){ 
        var el = $(this);
        var text = $(this).text();
        // Check if text contains arrow
        if (text.indexOf('↓') > -1) {
            el.html(text.replace('↓', '<span class="arrow">↓</span>'));
        }
        
        if (text.indexOf('→') > -1) {
            el.html(text.replace('→', '<span class="arrow">→</span>'));
        }
        
        el.find('.arrow').addClass('visible');
    });

    if ($('.full-video').length > 0) {
        if (sessionStorage.getItem('videoBg')) {
            $('.full-video-bg').fadeOut(300);
            
        } else {
            $('.full-video').addClass('visible');
            
            $('.full-video').on('click',function(){
                $(this).removeClass('visible');
                $('.full-video-bg').hide();
                sessionStorage.setItem('videoBg', true);
            });
        }
    }

    if (!localStorage.getItem('newsletter')) {
        $('.newsletter-popup').addClass('visible');
    }

    $('.newsletter-popup .close-popup').on('click',function(){
        $('.newsletter-popup').removeClass('visible');
        localStorage.setItem('newsletter', true);
    });

    $('#consent').on('change',function(){
        console.log('changed');
        if ($(this).is(':checked')) {
            $('.cart-checkout').removeClass('cta-disabled');
        } else {
            $('.cart-checkout').addClass('cta-disabled');
        }
    })

    $('.show-password-login').on('click',function(e){
        e.preventDefault();
        $('.password-newsletter').slideUp();
        setTimeout(function(){
            $('.password-login').slideDown();
        },500)
    });

    $('.hide-password-login').on('click',function(e){
        e.preventDefault();
        $('.password-login').slideUp();
        setTimeout(function(){
            $('.password-newsletter').slideDown();
        },500)
    });

    $('.notify-me .link').on('click',function(e){
        e.preventDefault();
        $(this).slideUp();
        setTimeout(function(){
            $('.notify-me-form').slideDown();
        },500);
    })

    $('.shop-toggle').on('click',function(e){
        var el = $(this);
        if ($(window).width() < 640) {
            e.preventDefault();
            el.toggleClass('active');
            $('.shop-subnav').slideToggle();
            $('.nav-logo').fadeToggle();
        }
    });

    $('.nav-logo').on('click',function(){
        location.href = '/';
    })

    $('.variant-square').on('click',function(){
        var id = $(this).data('id');
        $('.variant-square').removeClass('active');
        $(this).addClass('active');
        $('.id').find('option[value="' + id + '"]').prop('selected', true);
    });

    $('.collections-nav li a').each(function(){
        console.log($(this).text());
        if ($(this).text().indexOf('Oddbin') > -1) {
            var text = $(this).text().split(' ');
            console.log(text);
            text[1] = '<span class="red">' + text[1] + ' ' + text[2] + '</span>';
            text.splice(2,1);
            $(this).html(text.join(' '));
        }
    });

    if ($('.active-parent').length) {
        $('.collections-nav-wrap').addClass('black');
    }

    $('.collection-subnav li').each(function(){
        if ($(this).hasClass('active'))  {
            $(this).parent().parent().addClass('active-parent');
            $('.collections-nav-wrap').addClass('black');
        }
    });

    $('.show-password a').on('click',function(e){ 
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).text('Enter using password').removeClass('active');
            $('.password-sign-up').fadeIn();
            $('.password-enter').hide();
        } else {
            $(this).text('Sign up for updates').addClass('active');
            $('.password-enter').fadeIn();
            $('.password-sign-up').hide();
        }
    });

    function initSwiperOnContainer(el) {
        const swiperEl = el.querySelector('.swiper');
        if (!swiperEl || swiperEl.__swiperInitialized) return;
        const nextButton = el.querySelector('[data-swiper-next]');
        const prevButton = el.querySelector('[data-swiper-prev]');
        new Swiper(swiperEl, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: nextButton || undefined,
                prevEl: prevButton || undefined
            }
        });
        swiperEl.__swiperInitialized = true;
    }

    // init any existing ones
    document.querySelectorAll('[data-swiper]').forEach(initSwiperOnContainer);

    // observe future Vue renders
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
            m.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) return;
                if (node.matches && node.matches('[data-swiper]')) {
                    initSwiperOnContainer(node);
                } else {
                    node.querySelectorAll && node.querySelectorAll('[data-swiper]').forEach(initSwiperOnContainer);
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });

});

const tickers = document.querySelectorAll(".ticker");
function ensureContentWiderThanContainer(container, wrapper) {
    while (container.offsetWidth > wrapper.scrollWidth) {
        wrapper.innerHTML += wrapper.innerHTML;
    }
}
function cloneAndPlay(container, wrapper) {
    const clonedNode = wrapper.cloneNode(true);
    clonedNode.setAttribute("aria-hidden", "true");
    container.appendChild(clonedNode);
    container.classList.add("ticker--playing");
}
function setAnimationSpeed(container, wrapper) {
    const baseSpeed = 100; // pixels per second, adjust as needed
    const distance = wrapper.scrollWidth + window.innerWidth;
    const speed = distance / baseSpeed;
    container.setAttribute("style", `--ticker-animation-speed: ${speed}s;`);
}
document.addEventListener("DOMContentLoaded", () => {
    tickers.forEach((container) => {
        const wrapper = container.querySelector(".ticker-wrapper") || null;
        if (!wrapper) return;
        ensureContentWiderThanContainer(container, wrapper);
        cloneAndPlay(container, wrapper);
        setAnimationSpeed(container, wrapper);
        window.addEventListener("resize", () => {
            setAnimationSpeed(container, wrapper);
        });
    });
});